import React from 'react';
import { Intervention, Campaign } from '../../types';
import SetStatisticsPanel from '../Dashboard/SetStatisticsPanel';

interface StatsModalProps {
  show: boolean;
  interventions: Intervention[];
  campaigns: Campaign[];
  onClose: () => void;
}

// ===== Composant StatsModal =====
const StatsModal: React.FC<StatsModalProps> = ({ show, interventions, campaigns, onClose }) => {

  if (!show) return null;

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div
        className="modal-content modal-xl"
        style={{ maxWidth: '95vw', maxHeight: '95vh' }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-2xl font-bold text-gray-800 flex items-center">
            <i className="fas fa-chart-bar mr-3 text-blue-600"></i>
            <span>Statistiques des Interventions</span>
          </h3>
          <button
            onClick={onClose}
            className="modal-close text-gray-400 hover:text-gray-600 text-2xl"
          >
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div
          style={{ maxHeight: 'calc(95vh - 8rem)', overflowY: 'auto' }}
          className="space-y-6"
        >
          <SetStatisticsPanel campaigns={campaigns} />
        </div>
      </div>
    </div>
  );
};

export default StatsModal;
